<svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect y="0.146484" width="24" height="24" rx="12" fill="#E33D3D"/>
<path d="M12 10.935L16.2426 6.69238L17.4545 7.90431L13.2119 12.1469L17.4545 16.3895L16.2426 17.6015L12 13.3589L7.75734 17.6015L6.54541 16.3895L10.788 12.1469L6.54541 7.90431L7.75734 6.69238L12 10.935Z" fill="white"/>
</svg>
